/* LF PRIVÉ · Catálogo
   1) Filtro de intensidad: el metacampo custom.intensidad guarda números (1 a 5); aquí se muestran
      como Ligera, Suave, Moderada, Alta y Muy alta, también en las píldoras de filtros activos.
   2) Botón «Filtrar y ordenar» fijo abajo en celular.
   Aparece cuando el botón original de Dawn queda arriba fuera de la pantalla y se oculta al llegar
   al final de los productos. Al tocarlo abre el mismo panel de filtros de Dawn (no lo reemplaza)
   y, al cerrarlo, vuelve al punto donde estabas; si cambiaste filtros, sube al inicio de la grilla. */
(function () {
  var INT = { 1: 'Ligera', 2: 'Suave', 3: 'Moderada', 4: 'Alta', 5: 'Muy alta' };
  function relabel() {
    document.querySelectorAll('input[name$="custom.intensidad"]').forEach(function (inp) {
      var name = INT[inp.value];
      var label = inp.closest('label') || inp.parentNode;
      if (!name || !label) return;
      var t = label.querySelector('.facet-checkbox__text-label');
      if (t && t.textContent.trim() !== name) t.textContent = name;
      var vh = label.querySelector('.visually-hidden');
      if (vh && /^\s*[1-5]\b/.test(vh.textContent)) vh.textContent = vh.textContent.replace(/^\s*[1-5]\b/, name);
    });
    document.querySelectorAll('.active-facets__button-inner').forEach(function (el) {
      el.childNodes.forEach(function (n) {
        if (n.nodeType === 3 && /Intensidad:\s*[1-5]\b/.test(n.nodeValue)) {
          n.nodeValue = n.nodeValue.replace(/(Intensidad:\s*)([1-5])\b/, function (m, a, d) { return a + INT[d]; });
        }
      });
    });
  }
  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; relabel(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', relabel);
  else relabel();
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });

  if (customElements.get('lf-filter-float')) return;
  var mq = window.matchMedia('(max-width: 749px)');

  class LfFilterFloat extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('button');
      this.tick = this.tick.bind(this);
      this.btn.addEventListener('click', this.open.bind(this));
      window.addEventListener('scroll', this.tick, { passive: true });
      window.addEventListener('resize', this.tick);
      this.tick();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.tick);
      window.removeEventListener('resize', this.tick);
    }
    summary() {
      return document.querySelector('menu-drawer.mobile-facets__wrapper > details > summary');
    }
    tick() {
      if (this.raf) return;
      this.raf = requestAnimationFrame(() => {
        this.raf = 0;
        this.update();
      });
    }
    update() {
      var show = false;
      var s = this.summary();
      var grid = document.getElementById('product-grid');
      if (mq.matches && s && grid) {
        var details = s.parentNode;
        var sr = s.getBoundingClientRect();
        var gr = grid.getBoundingClientRect();
        show = !details.hasAttribute('open') && sr.bottom < 0 && gr.bottom > window.innerHeight - 40;
      }
      if (show === this.classList.contains('is-visible')) return;
      if (show) {
        this.hidden = false;
        requestAnimationFrame(() => this.classList.add('is-visible'));
      } else {
        this.classList.remove('is-visible');
        clearTimeout(this.hideT);
        this.hideT = setTimeout(() => {
          if (!this.classList.contains('is-visible')) this.hidden = true;
        }, 220);
      }
    }
    open() {
      var s = this.summary();
      if (!s) return;
      var details = s.parentNode;
      var y = window.scrollY;
      var query = window.location.search;
      var restore = function () { window.scrollTo(0, y); };
      var onToggle = function () {
        if (details.hasAttribute('open')) return;
        details.removeEventListener('toggle', onToggle);
        setTimeout(function () {
          if (window.location.search !== query) {
            var g = document.getElementById('ProductGridContainer');
            if (g) window.scrollTo(0, Math.max(0, g.getBoundingClientRect().top + window.scrollY - 90));
          } else {
            restore();
          }
        }, 60);
      };
      details.addEventListener('toggle', onToggle);
      s.click();
      requestAnimationFrame(restore);
      this.classList.remove('is-visible');
      this.hidden = true;
    }
  }
  customElements.define('lf-filter-float', LfFilterFloat);
})();
